import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
// Public canonical domain (used for SEO: canonical, OG, JSON-LD). Falls back to backend URL.
export const SITE_URL = process.env.REACT_APP_SITE_URL || BACKEND_URL;

const http = axios.create({ baseURL: API, timeout: 9000 });

export const fetchLatestResult = async () => (await http.get("/result/latest")).data;

export const fetchPreviousResults = async (variant, page = 1, limit = 15) =>
  (await http.get("/results/previous", { params: { variant, page, limit } })).data;

export const fetchCommonNumber = async (variant) =>
  (await http.get("/common-number", { params: { variant } })).data;

export const fetchNews = async () => (await http.get("/news")).data;
